// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateGame_container__Z\\+Ooy {
  animation: CreateGame_init__QcHwj 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

/*---Title---*/
.CreateGame_container__Z\\+Ooy .CreateGame_titleContainer__2zuvU {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.CreateGame_container__Z\\+Ooy .CreateGame_titleContainer__2zuvU h4 {
  width: 95%;
  text-align: center;
  font-size: 1.8rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.CreateGame_container__Z\\+Ooy .CreateGame_titleContainer__2zuvU .CreateGame_arrow__mDL\\+P {
  transition: 0.3s;
}

.CreateGame_container__Z\\+Ooy .CreateGame_titleContainer__2zuvU .CreateGame_arrow__mDL\\+P:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_switch__Bgvjh {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_switch__Bgvjh p {
  margin: 30px 0 0;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_switch__Bgvjh .CreateGame_titleinput__mtZZT {
  font-size: 1.2rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_main__YS5x4 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_main__YS5x4 .CreateGame_image__W3GKH {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: auto;
  margin-right: 30px;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_main__YS5x4 .CreateGame_image__W3GKH .CreateGame_imageIcon__CTL-P {
  transition: 0.3s;
  background-color: rgba(154, 154, 154, 0.252);
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  width: 100%;
  height: 90%;
  object-fit: contain;
  border-radius: 10px;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_main__YS5x4 .CreateGame_image__W3GKH .CreateGame_editButton__BQD5v {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 120px;
  height: 35px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
  border-radius: 5px;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_main__YS5x4 .CreateGame_image__W3GKH .CreateGame_editButton__BQD5v:hover {
  transition: 0.3s;
  scale: 1.04;
  filter: brightness(1.2);
  cursor: pointer;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_main__YS5x4 .CreateGame_image__W3GKH .CreateGame_addImageIcon__lCXjX {
  transition: 0.3s;
  background-color: rgba(154, 154, 154, 0.252);
  font-size: 3rem;
  padding: 50px;
  border-radius: 100%;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_main__YS5x4 .CreateGame_image__W3GKH .CreateGame_addImageIcon__lCXjX:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(1.2);
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_inputItem__w7qwg {
  margin-bottom: 20px;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.CreateGame_container__Z\\+Ooy .CreateGame_form__2wP98 .CreateGame_inputItem__w7qwg .CreateGame_titleinput__mtZZT {
  width: 80%;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: Roboto, sans-serif;
}

.CreateGame_submit__xbZMk {
  width: 80%;
}

@keyframes CreateGame_init__QcHwj {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Juegos/Create/CreateGame.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,8CAA8C;EAC9C,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 95%;\n  text-align: center;\n  font-size: 1.8rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .form {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .form .switch {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.container .form .switch p {\n  margin: 30px 0 0;\n}\n\n.container .form .switch .titleinput {\n  font-size: 1.2rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .form .main {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.container .form .main .image {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: auto;\n  margin-right: 30px;\n}\n\n.container .form .main .image .imageIcon {\n  transition: 0.3s;\n  background-color: rgba(154, 154, 154, 0.252);\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  width: 100%;\n  height: 90%;\n  object-fit: contain;\n  border-radius: 10px;\n}\n\n.container .form .main .image .editButton {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  width: 120px;\n  height: 35px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n  border-radius: 5px;\n}\n\n.container .form .main .image .editButton:hover {\n  transition: 0.3s;\n  scale: 1.04;\n  filter: brightness(1.2);\n  cursor: pointer;\n}\n\n.container .form .main .image .addImageIcon {\n  transition: 0.3s;\n  background-color: rgba(154, 154, 154, 0.252);\n  font-size: 3rem;\n  padding: 50px;\n  border-radius: 100%;\n}\n\n.container .form .main .image .addImageIcon:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(1.2);\n}\n\n.container .form .inputItem {\n  margin-bottom: 20px;\n  margin-left: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.container .form .inputItem .titleinput {\n  width: 80%;\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: Roboto, sans-serif;\n}\n\n.submit {\n  width: 80%;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CreateGame_container__Z+Ooy`,
	"init": `CreateGame_init__QcHwj`,
	"titleContainer": `CreateGame_titleContainer__2zuvU`,
	"arrow": `CreateGame_arrow__mDL+P`,
	"form": `CreateGame_form__2wP98`,
	"switch": `CreateGame_switch__Bgvjh`,
	"titleinput": `CreateGame_titleinput__mtZZT`,
	"main": `CreateGame_main__YS5x4`,
	"image": `CreateGame_image__W3GKH`,
	"imageIcon": `CreateGame_imageIcon__CTL-P`,
	"editButton": `CreateGame_editButton__BQD5v`,
	"addImageIcon": `CreateGame_addImageIcon__lCXjX`,
	"inputItem": `CreateGame_inputItem__w7qwg`,
	"submit": `CreateGame_submit__xbZMk`
};
export default ___CSS_LOADER_EXPORT___;
